import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { noop } from 'ui-components/default-props/noop';

import { MappingImportStepFooter } from './mapping-import-step';
import { actionMap, initialState } from './reducer';
import { ImportType } from '../../../../../../../components/csv-import/data/types/import-type';
import { StepType } from '../../../../../../../components/csv-import/data/types/step-type';
import { ImportProvider } from '../../../../../../../components/csv-import/ui/components/import-context';
import { SingleImportDrawer } from '../../../../../../../components/csv-import/ui/components/single-import-drawer/single-import-drawer';
import { CreateMappingStepBody } from '../../../../../../../components/csv-import/ui/components/steps/create-mapping-step/create-mapping-step';
import {
  ImportIsProcessingStepBody,
  ImportIsProcessingStepFooter,
} from '../../../../../../../components/csv-import/ui/components/steps/import-is-processing-step/import-is-processing-step';
import { useCsvImport } from '../../../../../../../components/csv-import/ui/hooks/use-csv-import';
import { getTranslationFn } from '../../../../../../../components/csv-import/ui/utils';
import { CSV_PRODUCT_IMPORT_JOB_COMPLETE } from '../../../../../../../services/pusher-service/pusher-contract-messages';
import { fieldsTranslations, messages } from '../../../../../../products-page/products/modals/import/product-import-drawer/messages';

const translateField = getTranslationFn(fieldsTranslations, ImportType.fulfillmentProduct);

const createCustomImportSettings = (form) => {
  return {
    overwriteExisting: form.updateExistingProducts,
  };
};

export const FulfillmentProductImport = ({ children }) => {
  const { isOpen } = useCsvImport(ImportType.fulfillmentProduct);

  const steps = useMemo(
    () => [
      {
        id: StepType.CREATE_CONFIG,
        title: <FormattedMessage {...messages.createConfigStep} />,
      },
      {
        id: StepType.CREATE_MAPPING,
        title: <FormattedMessage {...messages.createMappingStep} />,
        body: <CreateMappingStepBody />,
        footer: <MappingImportStepFooter />,
      },
      {
        id: StepType.IMPORT_IS_PROCESSING,
        title: <FormattedMessage {...messages.importResult} />,
        body: (
          <ImportIsProcessingStepBody
            successMessage={<FormattedMessage {...messages.importResultSuccess} />}
            title={<FormattedMessage {...messages.importResult} />}
          />
        ),
        footer: <ImportIsProcessingStepFooter />,
      },
    ],
    [],
  );

  const { close } = useCsvImport(ImportType.fulfillmentProduct);

  const onCancel = () => close;

  return (
    <ImportProvider
      actionMap={actionMap}
      createCustomImportSettings={createCustomImportSettings}
      importType={ImportType.fulfillmentProduct}
      initialState={initialState}
      onClose={close}
      pusherEvent={CSV_PRODUCT_IMPORT_JOB_COMPLETE}
      trackProcess={noop}
      translateField={translateField}
    >
      <>
        {children}
        {isOpen ? (
          <SingleImportDrawer
            header={<FormattedMessage {...messages.modalDrawer} />}
            onCancel={onCancel}
            startStepId={StepType.CREATE_MAPPING}
            steps={steps}
          />
        ) : null}
      </>
    </ImportProvider>
  );
};
